import CircleChart from 'components/CircleChart'
import { ccb } from 'assets/Icons'
import { formatInvestCard, calcularContraste } from 'helper/utils'
import { useContext } from 'react'
import { UserContext } from 'context/userContext'
import { IMAGES } from 'configs/configs.js'
import {
  Gradient,
  TagText,
  ColoredTag,
  Tags,
  MinRow,
  InvestTitle,
  CardContainer,
  RateColoured,
  RateText,
  InvestText,
  MoneyText,
  Container,
  Card,
  ImageContentStyle,
  ImageContainer,
  GuaranteeFlag,
  GuaranteeText,
} from './style'

interface IInvestCardProps {
  item: any
  onClick?: (..._param: any) => void
  isPreview?: boolean
  shadow?: boolean
  isEnterprise?: boolean
}

interface IImageContentProps {
  item: any
  isPreview?: boolean
  isEnterprise?: boolean
}

interface ICardContentProps {
  item: any
}

const ImageContent = ({
  item,
  isPreview,
  isEnterprise,
}: IImageContentProps) => {
  const { preview } = useContext(UserContext)
  const image = isPreview
    ? preview
    : `${IMAGES.URL}/images/${item?.style?.image?.name}`
  const [color] = item?.style?.color || ['#565656']

  const getGuaranteeText = (
    guarantees: string[] | undefined
  ): string | null => {
    if (!guarantees || guarantees.length === 0) return null

    console.log('guarantees', guarantees)

    const firstGuarantee = guarantees[0]

    if (
      firstGuarantee === 'SPE' ||
      firstGuarantee === 'Não possui' ||
      firstGuarantee == null
    ) {
      return null
    }

    const guaranteeMap: Record<string, string> = {
      SEG: 'Seguro',
      'Alienação fiduciária': 'Alienação f',
      'Aval dos sócios': 'Aval sócios',
      // adicione outras siglas
    }

    if (guarantees.length === 1) {
      return guaranteeMap[firstGuarantee] || firstGuarantee
    }

    return `${guarantees.length} Garantias`
  }

  const guaranteeText = getGuaranteeText(item.guarantee)

  return (
    <ImageContainer img={image}>
      {guaranteeText && (
        <GuaranteeFlag>
          <GuaranteeText>{guaranteeText}</GuaranteeText>
        </GuaranteeFlag>
      )}
      <Gradient opacity={item?.style?.image?.opacity} className="gradient">
        <ImageContentStyle className="image-container">
          <Tags start>
            {item.tags.map((tag: string) => (
              <ColoredTag color={'black'} key={`color-tag-poster-${tag}`}>
                <TagText color={'#FFF'}>{tag}</TagText>
              </ColoredTag>
            ))}
          </Tags>

          <MinRow start>
            <img className="svg-card-icon" src={ccb} alt="card icon" />
            <InvestTitle>{`${item?.name}${
              isEnterprise ? '' : `/${item?.createdAtYear}`
            }`}</InvestTitle>
          </MinRow>
        </ImageContentStyle>
      </Gradient>
    </ImageContainer>
  )
}

const CardContent = ({ item }: ICardContentProps) => {
  const [color] = item?.style?.color || ['#565656']
  return (
    <CardContainer isEvenly={!item?.url}>
      <>
        {item?.chart && (
          <CircleChart
            radius={55}
            valueArray={item?.chart?.sectionList}
            strokeWidth={3}
          >
            <RateColoured color={color} className="rate">
              {item.chart.title}
            </RateColoured>
            <RateText>{item.chart.subtitle}</RateText>
          </CircleChart>
        )}
        {item?.label && (
          <MinRow center>
            <InvestText>{`${item?.label}:`}</InvestText>
            <MoneyText>{`${
              item?.value === undefined ? 0 : item?.value
            }`}</MoneyText>
          </MinRow>
        )}
      </>
    </CardContainer>
  )
}

const InvestCard = ({
  item,
  onClick,
  isPreview = false,
  shadow,
  isEnterprise = false,
}: IInvestCardProps) => {
  const data = formatInvestCard(item)
  const [color] = item?.style?.color || ['#565656']

  return (
    <Container key={`label_poster_card`} shadow={shadow} color={color}>
      <Card shadow={shadow} onClick={onClick}>
        <ImageContent
          isPreview={isPreview}
          item={data}
          isEnterprise={isEnterprise}
        />
        <CardContent item={data} />
      </Card>
    </Container>
  )
}

export default InvestCard
